import React, { useEffect } from "react"
import { FileUploader } from "react-drag-drop-files"
import { DocumentPlusIcon } from "@heroicons/react/24/solid"
import { Image } from "~/components/Admin/SitePhotoUpload"
import { useCampImageUploader } from "~/hooks/useCampImageUploader"
import { CampProps } from "~/interfaces"

const CampLogoUpload = ({ camp }: { camp: CampProps }) => {
  const { fetchCampImages, handleAddCampImages, handleRemoveCampImage, logo } = useCampImageUploader(camp)

  useEffect(() => {
    fetchCampImages("logo")
  }, [])

  return (
    <div className="w-full mb-6">
      <div className="text-base font-semibold">Business Logo</div>
      <div className="flex justify-between gap-4 mt-2">
        <div className="flex-1">
          <FileUploader
            handleChange={(file: File) => handleAddCampImages(file, "logo")}
            name="logo"
            types={["JPG", "JPEG", "PNG"]}
            multiple={false}
            children={
              <div className="border-2 border-dashed border-gray-300 p-8 h-24 flex items-center rounded-md cursor-pointer hover:bg-gray-75 w-full">
                <DocumentPlusIcon className="w-8 h-8 text-gray-500 mr-4" />
                <div className="flex justify-between w-full">
                  <span className="text-gray-600 text-md">
                    Click or drag a logo here to {(logo && "replace") || "upload"}
                  </span>
                  <span className="text-gray-500 text-md">jpg, png, jpeg</span>
                </div>
              </div>
            }
          />
        </div>
        {logo && (
          <Image
            src={logo.url}
            handleRemove={() => handleRemoveCampImage(logo?.key, "logo")}
            isLoading={logo.isLoading}
            onLoaded={() => {}}
            onError={() => {}}
          />
        )}
      </div>
    </div>
  )
}

export default CampLogoUpload
